import React from 'react';
import { Container } from 'layouts';
import { useSubMenu } from 'hooks';
import { SubMenuList } from 'components';

export function MyHome(props) {
  const subMenu = useSubMenu();

  return (
    <Container title="My">
      <SubMenuList list={subMenu} />
    </Container>
  );
}
